import React from 'react';
import styles from '../assets/styles/Navbar.module.css';
import ContactDetailLabelNav from './ContactDetailLabelNav';
import LogoPng from '../assets/images/logo.jpg';
import { Link } from 'react-router-dom';
import { FaPhoneAlt } from "react-icons/fa";
import { MdEmail } from "react-icons/md";

const Navbar = () => {
  return (
    <div className={styles.navbar}>
      <div className={styles.navbarTop}>
        <div className={styles.navbarTopContent}>
          <div className={styles.contactDetails}>
          <ContactDetailLabelNav href="tel:+61 416 185 595" icon={<FaPhoneAlt />} text="0416 185 595 (Kimani)" />
          <ContactDetailLabelNav href="tel:+61 424 441 114" icon={<FaPhoneAlt />} text="0424 441 114 (Yusef)" />
          <ContactDetailLabelNav href="mailto:info@starnetlegal.com.au" icon={<MdEmail />} text="info@starnetlegal.com.au" />
          </div>
          <Link to="/#contact" className={styles.ctaButton}>Book a Consult</Link>
        </div>
      </div>
      <div className={styles.navbarBottom}>
        <div className={styles.logo}>
          <Link to="/">
            <img src={LogoPng} alt="Starnet Legal Logo" className={styles.logoImage} />
          </Link>
        </div>
        <div className={styles.navOptions}>
          <div className={styles.navOptionContainer}>
            <Link to="/" className={styles.navOption}>Home</Link>
          </div>
          <div className={styles.navOptionContainer}>
            <Link to="/about" className={styles.navOption}>Who We Are</Link>
          </div>
          <div className={styles.navOptionContainer}>
            <Link to="/#services" className={styles.navOption}>What We Do</Link>
          </div>
          <div className={styles.navOptionContainer}>
            <Link to="/#contact" className={styles.navOption}>How to Contact Us</Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Navbar;